<div>
  &lt;{{ mouseTarget?.localName }}{{ mouseTarget?.id ? ' id="' +mouseTarget.id+ '"' : '' }}&gt;
</div>
